'use strict';

export default {
  organizationPage: {
    organization: 'Organization',
    save: 'Save',
    picture: 'Change picture',
    nameError: 'Name cannot be empty',
    empty: ' ',
    selection: {
      title: 'Choose your organization',
      addOrganization: 'Add Organization',
      welcome: 'Welcome ',
      choose: 'Time to choose your organization',
      noOrganizations: 'There are no organizations to show',
      addOrganizationMessage: 'To add an organization, please contact ',
    },
  },
};
